import { Injectable } from '@angular/core';

import { map } from 'rxjs/operators';
import { ScopeService } from '../utils';

@Injectable()
export class EnergyGuard  {

  constructor(
    private scopeService: ScopeService,
  ) { }

  canActivate() {
    return this.scopeService.user$
      .pipe(
        map((user) => user.can_access_energy),
      );
  }
}
